import React, {useRef} from "react";
import {Fade, IconButton, TextField} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';

export default function ControlledTextField({
                                                inputNewRef,
                                                placeholder,
                                                label,
                                                value,
                                                setValue,
                                                margin,
                                                handleInput,
                                                startAdornment,
                                                handler,
                                                handleFocus,
                                                endAdornment,
                                                handleBlur,
                                                sx,
                                                autoFocus,
                                                onKeyPress,
                                                type,
                                                className,
                                                handleClick,
                                                textFieldSx,
                                                renderEndAdornment = true,
                                                refs,
                                                transitionEnd
                                            }) {

    const handleChange = (event) => {
        setValue(event.target.value);
        if (handler) {
            handler(event.target.value);
        }
    };

    const inputRef = useRef(null);
    return (
        <TextField
            sx={textFieldSx}
            placeholder={placeholder}
            onKeyPress={onKeyPress}
            autoFocus={autoFocus}
            fullWidth
            value={value}
            label={label}
            inputRef={inputNewRef ?? inputRef}
            ref={refs}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onClick={handleClick}
            variant='outlined'
            margin={margin}
            onInput={handleInput}
            onTransitionEnd={transitionEnd}
            InputProps={{
                type: type ?? undefined,
                style: sx,
                startAdornment: startAdornment,
                ...(renderEndAdornment && {
                    endAdornment: (
                        <>
                            <Fade in={value !== ''}>
                                <IconButton onClick={() => {
                                    setValue('')
                                    if (inputNewRef.current) {
                                        inputNewRef?.current?.focus();
                                    } else {
                                        inputRef?.current?.focus();
                                    }
                                }}>
                                    <ClearIcon fontSize={'small'}/>
                                </IconButton>
                            </Fade>
                            {endAdornment}
                        </>
                    )
                })
            }}
            className={className}
        />
    );
}